import React, { Fragment, useState } from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import Overlay from "components/Overlay";
import ConstantCheckoutBuilder from "../ConstantCheckoutBuilder";
import CombinationResult from "../CombinationResult";
import { STATE_KEYS } from "utils/constants/state";
import { SET_CONSTANT_GUIDANCE } from "utils/constants/checkout";
import HoverIconButton from "components/HoverIconButton";
import { useSetManifestLogicType } from "utils/hooks/manifest";

const CHECKOUT_PICKER_INTENT = {
  SELECT_RESULT: "SELECT_RESULT"
};

const ConstantCheckoutShow = ({ name }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const checkoutConstantPath = `${name}.${STATE_KEYS.FORM.CONFIG_LOGIC_CHECKOUTS_CONSTANT}`;
  const checkoutConstant = get(values, checkoutConstantPath);
  const hasCheckoutConstant = !isEmpty(checkoutConstant);

  /**
   * If we clear the constant checkout value
   * Then check whether we need to update the manifest conditional type
   */
  useSetManifestLogicType({ name });

  /**
   * Allow the user to toggle between product and price pick intent
   */
  const [intent, setIntent] = useState(null);

  let overlayContent;
  const showOverlay = Boolean(intent);
  const setResult = (combinationResult) => {
    /**
     * NOTE:
     * - Important that we set the whole checkout object to be null when no primaries are present
     * - Don't want to mistakenly inflate the checkout with stray discounts / non product related configuration
     */
    const updatedCheckout =
      combinationResult && !isEmpty(combinationResult.primaries)
        ? combinationResult
        : null;
    setFieldValue(checkoutConstantPath, updatedCheckout);
    const isTouched = get(touched, checkoutConstantPath);
    if (!isTouched) {
      setFieldTouched(checkoutConstantPath, true);
    }
    setIntent(null);
  };

  const showPicker = () => setIntent(CHECKOUT_PICKER_INTENT.SELECT_RESULT);

  if (intent === CHECKOUT_PICKER_INTENT.SELECT_RESULT) {
    overlayContent = (
      <ConstantCheckoutBuilder
        name={name}
        goBack={setResult}
        hideBuilder={() => setIntent(null)}
      />
    );
  }

  const checkoutConstantTrigger = hasCheckoutConstant ? (
    <div
      className="f6 fw6 link__decoration--hover color-primary pointer"
      onClick={showPicker}
    >
      Edit
    </div>
  ) : null;

  return (
    <Fragment>
      <div className="pa3 flex flex-column bb hairline-1 bg-white bh--inset">
        <div className="f6 w-100 lh-copy">{SET_CONSTANT_GUIDANCE}</div>
        <div className="flex flex-row justify-between pt2">
          {checkoutConstantTrigger ? (
            <div className="pt2">{checkoutConstantTrigger}</div>
          ) : null}

          <div className="dib">
            <HoverIconButton
              type="refresh"
              tooltip="Clear"
              onClick={() => setResult(null)}
              disabled={!hasCheckoutConstant}
            />
          </div>
        </div>
      </div>
      <div
        onClick={() => setIntent(CHECKOUT_PICKER_INTENT.SELECT_RESULT)}
        className="pa3 bg-white--hover bh--inset--hover pointer"
      >
        <CombinationResult result={checkoutConstant} />
      </div>
      {showOverlay && overlayContent && (
        <Overlay hideOverlay={() => setIntent(null)}>{overlayContent}</Overlay>
      )}
    </Fragment>
  );
};

export default ConstantCheckoutShow;
